import { useCallback, useMemo } from 'react';
import find from 'lodash/find';
import { useHistory, useParams } from 'react-router-dom';

export default function useTabPages({
  basePath = '',
  pages = [],
  slugParam = 'tab',
} = {}) {
  const history = useHistory();
  const params = useParams();
  const tabSlug = params[slugParam];

  const tabs = useMemo(() => pages.map((p) => p.tab), [pages]);

  const activePage = useMemo(
    () => find(pages, (p) => p.tab.slug === tabSlug),
    [pages, tabSlug]
  );

  const onGoToTab = useCallback(
    (slug) => {
      history.push(`${basePath}${slug}`);
    },
    [history, basePath]
  );

  return {
    tabs,
    activePage,
    onGoToTab,
  };
}
